import { render, staticRenderFns } from "./IconQuoteStart.vue?vue&type=template&id=1c927edb&"
import script from "./IconQuoteStart.vue?vue&type=script&lang=ts&"
export * from "./IconQuoteStart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports